import { useState, useEffect } from 'react';
import toSafeInteger from 'lodash/toSafeInteger';
// local imports
import { Skill, SkillLevel, SKILL_LEVEL_ADVANCED } from '../models/skill';

// the skill precondition reads the raw stored/inferred levels, not the supersession-aware helpers: a stored
// level 3 that a newer lower inference supersedes still exempts the skill, because the employee once confirmed 3
function useLevelConfirmation(
  skill: Skill | null | undefined,
  level: SkillLevel,
  requireLevelConfirm?: boolean | null,
  testConfirmed?: boolean
) {
  const { id, current_level, actual_level, inferred_level } = skill || {};
  const [levelConfirmed, setLevelConfirmed] = useState<boolean>(Boolean(testConfirmed));
  useEffect(() => {
    if (!testConfirmed) setLevelConfirmed(false);
  }, [id, level, testConfirmed]);
  const showLevelConfirm = Boolean(requireLevelConfirm) && level >= SKILL_LEVEL_ADVANCED &&
    toSafeInteger(current_level ?? actual_level) < SKILL_LEVEL_ADVANCED &&
    toSafeInteger(inferred_level) < SKILL_LEVEL_ADVANCED;
  return { showLevelConfirm, levelConfirmed, setLevelConfirmed };
}

export default useLevelConfirmation;
